import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface RevealOnScrollProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function RevealOnScroll({
  children,
  className = '',
  delay = 0
}: RevealOnScrollProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10%'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 20
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-247">
      {children}
    </motion.div>;
}